import * as React from 'react';

const Pin = () => (
  <div
    style={{
      fontSize: 35,
      lineHeight: 1,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      // {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#D84A1B"
          stroke="#fff"
          d="M12 1.875c4.146 0 7.5 3.354 7.5 7.5 0 1.84-.53 3.561-1.496 5.105h-.001c-.49.8-1.055 1.536-1.604 2.247-.416.54-.82 1.065-1.194 1.606l-.361.548c-.451.72-.77 1.394-1.139 2.202-.056.125-.105.259-.18.445-.07.172-.157.372-.268.559-.225.378-.61.788-1.257.788-.648 0-1.032-.41-1.258-.786a4.169 4.169 0 0 1-.268-.557c-.077-.185-.128-.32-.186-.443l-.005-.01c-.355-.801-.685-1.477-1.137-2.198v-.001c-.465-.745-1.002-1.44-1.556-2.16-.55-.711-1.115-1.447-1.606-2.242v-.001C5.03 12.934 4.5 11.214 4.5 9.375c0-4.146 3.354-7.5 7.5-7.5Zm0 5.75a2 2 0 1 0 .002 4.002A2 2 0 0 0 12 7.625Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .375h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
export default Pin;
